import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=623ea380&scoped=true"
import script from "./Brands.vue?vue&type=script&lang=js"
export * from "./Brands.vue?vue&type=script&lang=js"
import style0 from "./Brands.vue?vue&type=style&index=0&id=623ea380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ea380",
  null
  
)

export default component.exports